import Swiper from 'swiper';
import SwiperCore, { Pagination } from 'swiper/core';
SwiperCore.use([Pagination]);

document.addEventListener("DOMContentLoaded", () => {
  let jobsContainers = document.querySelectorAll('.page__jobs');
  if (jobsContainers) {
    jobsContainers.forEach((jobsContainer) => {
      let swiperContainer = jobsContainer.querySelector('.swiper-container');
      if (swiperContainer) {
        new Swiper(swiperContainer, {
          slidesPerView: 'auto',
          centeredSlides: true,
          loopedSlides: 10,
          loop: true,
          spaceBetween: 40,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets',
          },
        });
      }
    });
  }
});
